import React from 'react';

interface GoogleAuthIconProps {
  className?: string;
  size?: number;
}

/**
 * Icône officielle Google Authenticator
 * Représente l'étoile/moulinet à 4 couleurs officielles de Google (Bleu, Rouge, Jaune, Vert).
 */
export const GoogleAuthIcon: React.FC<GoogleAuthIconProps> = ({
  className = 'w-6 h-6',
  size
}) => (
  <svg
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`shrink-0 ${className}`}
    style={size ? { width: size, height: size } : undefined}
    aria-label="Google Authenticator"
    role="img"
  >
    {/* Branche Bleue (Droite) */}
    <path
      fill="#1A73E8"
      d="M440 256c0 17.12-13.88 31-31 31H302l-46-93.01 49.65-86c8.56-14.82 27.52-19.9 42.35-11.34l.01.01c14.82 8.56 19.9 27.51 11.34 42.34L309.7 225H409c17.12 0 31 13.88 31 31z"
    />
    {/* Branche Rouge (Bas) */}
    <path
      fill="#EA4335"
      d="M348 415.35c-14.83 8.56-33.78 3.48-42.35-11.35L256 318.01l-49.65 86c-8.56 14.82-27.52 19.9-42.35 11.34l-.01-.01c-14.82-8.56-19.9-27.51-11.34-42.34L202.3 287l53.7-2 53.7 2 49.65 86c8.56 14.83 3.48 33.79-11.35 42.35z"
    />
    {/* Branche Jaune (Haut Gauche) */}
    <path
      fill="#FBBC04"
      d="M256 193.99L242 232l-39.7-7-49.65-86c-8.56-14.83-3.48-33.79 11.35-42.35l.01-.01c14.82-8.56 33.78-3.48 42.34 11.35L256 193.99z"
    />
    {/* Branche Verte (Gauche) */}
    <path
      fill="#34A853"
      d="M248 225l-36 62H103c-17.12 0-31-13.88-31-31s13.88-31 31-31h145z"
    />
    {/* Jonction Centrale */}
    <polygon fill="#185DB7" points="309.7,287 202.3,287 256,193.99" />
  </svg>
);

export default GoogleAuthIcon;
